module.exports = __webpack_public_path__ + "img/kws_blue.a1c53a73.svg";